// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__b71 {
  display: flex;
  flex-direction: column;
  padding: var(--ring-unit);
  width: 100%;
}

.rule__d33 {
  padding-top: calc(var(--ring-unit) * 2);
  padding-bottom: calc(var(--ring-unit) * 2);

  &:last-child {
    padding-bottom: 0;
  }

  & + .rule__d33 {
    border-top: 1px solid var(--ring-borders-color);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/profiles/profile-details/profile-ide-provisioner/plugin-rules/bundles/plugin-rules-bundle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;;EAE1C;IACE,iBAAiB;EACnB;;EAEA;IACE,+CAA+C;EACjD;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  padding: var(--ring-unit);\n  width: 100%;\n}\n\n.rule {\n  padding-top: calc(var(--ring-unit) * 2);\n  padding-bottom: calc(var(--ring-unit) * 2);\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n\n  & + .rule {\n    border-top: 1px solid var(--ring-borders-color);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__b71`,
	"rule": `rule__d33`
};
export default ___CSS_LOADER_EXPORT___;
